import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeWeightData } from "@/__mocks__/vitals/weight";
import type { WeightTrackingOverviewProps } from "@/ui/components/vitals/overview/WeightTrackingOverview";
import WeightTrackingOverview from "@/ui/components/vitals/overview/WeightTrackingOverview";
import { Box } from "@/ui/layout";
import { sortObservationsByDate } from "@/utils/vitals/weight.util";

const exampleData = [
  fakeWeightData({
    observation: {
      observationDatetime: new Date().toISOString(),
    },
  }),
  fakeWeightData({
    observation: {
      observationDatetime: faker.date.recent({ days: 7 }).toISOString(),
    },
  }),
  fakeWeightData({
    observation: {
      observationDatetime: faker.date.recent({ days: 30 }).toISOString(),
    },
  }),
  fakeWeightData({
    observation: {
      observationDatetime: faker.date.recent({ days: 100 }).toISOString(),
    },
  }),
];

const data = sortObservationsByDate({ data: exampleData, isDescending: false });

const StoryMeta: Meta<WeightTrackingOverviewProps> = {
  title: "Components/Vitals/Weight/Overview",
  component: WeightTrackingOverview,
  argTypes: {
    data: { control: "object" },
    selectedUserId: { control: "text" },
  },
  args: {
    data,
    selectedUserId: "",
  },
  render: (props) => (
    <Box width="100%">
      <WeightTrackingOverview {...props} />
    </Box>
  ),
};

type Story = StoryObj<WeightTrackingOverviewProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
